import * as Yup from "yup";

export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            type: "configue",
        },
        {
            title: " Name",
            value: "name",
            type: "configue",
        },
        {
            title: "Created At",
            value: "createdAt",
            type: "configue",
        },
        {
            title: "Updated At",
            value: "updatedAt",
            type: "configue",
            name: "updatedAt"
        },
        {
            title: "Created By",
            value: "createdByName",
            type: "configue",
        },
        {
            title: "Updated By",
            value: "updatedByName",
            type: "configue",
            name: "updatedByName"
        }
    ],
    secondaryData: [],
};

export type projects = {
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    createdById: string;
    updatedById: string;
    createdByName: string;
    updatedByName: string;
};

export const projectsInitialValues: projects = {
    id: "",
    name: "",
    createdAt: "",
    updatedAt: "",
    createdById: "",
    updatedById: "",
    createdByName: "",
    updatedByName: "",
};

export const projectsMandatoryFields = [{ id: "name" }];

export const projectsValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
});

export const projectsProperties = [

    {
        id: "name",
        type: "text",
        label: `Name`,
        className: "name-styles",
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: true,
    },
];
